
const __nuxt_page_meta = {}
export default __nuxt_page_meta
